import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { TvkAutocompleteTrigger } from './autocomplete/autocomplete.trigger';
import { MatAutocompleteModule, MatFormFieldModule, MatInputModule } from '@angular/material';
import { AutoCompleteLabelFunctionPipe } from './autocomplete/pipe/label-function.pipe';



@NgModule({
  declarations: [
    AutocompleteComponent,
    TvkAutocompleteTrigger,
    AutoCompleteLabelFunctionPipe
  ],
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule
  ],
  exports: [    
    AutocompleteComponent,
    TvkAutocompleteTrigger
  ]
})
export class ComponentsModule { }
